<template>
    <div :ref="'container'"
         style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; overflow-y: auto; height: 100%; min-height: 100%"
         :class="getCSSClass('pdf-viewer-container')">
        <div class="pdfViewer"></div>
    </div>
</template>

<script>
export default {
    inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],

    props: {
        url: {type: String},
    },
    data: function () {
        return {
        }
    },
    mounted() {
        this.loadPdf();
        window.addEventListener('keyup', this.closeOnEsc);

    },
    methods: {
        closeOnEsc: function(event) {
            if ((event.key) && (event.key == 'Escape')) {
                this.$emit('close');
            }
        },

        loadPdf: async function() {
            this.$emit('loadingflag', true);
            const eventBus = new pdfjsViewer.EventBus();
            const pdfLinkService = new pdfjsViewer.PDFLinkService({
                eventBus,
            });
            const container = this.$refs['container'];
            const viewer = new pdfjsViewer.PDFViewer({
                container,
                eventBus,
                linkService: pdfLinkService,
            });
            const url = this.url;
            pdfLinkService.setViewer(viewer);

            const loadingTask = pdfjsLib.getDocument({
                url: url,
                cMapUrl: '/js/pdf/cmaps/',
                cMapPacked: true,
                enableXfa: true,
            });
            let vm = this;
            loadingTask.promise.then(function (pdfDocument) {
                // Document loaded, specifying document for the viewer and
                // the (optional) linkService.
                viewer.setDocument(pdfDocument);
                vm.$emit('loadingflag', false);
                pdfLinkService.setDocument(pdfDocument, null);
            });
        }

    },
    computed: {},
    watch: {
        url: function() {
            this.loadPdf();
        }
    }

}
</script>
<style>
    .page {
        margin-bottom: 2rem !important;
        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    }
</style>
